interface InfoItemProps {
  label: string
  value: string | undefined
  bold?: boolean
  'data-testid'?: string
}

export const InfoItem = ({ label, value, bold = false, 'data-testid': dataTestId }: InfoItemProps) => {
  return (
    <span className="flex gap-4 border-b-1 py-2 text-sm" data-testid={dataTestId}>
      <p className="min-w-22">{label}</p>
      <p className={bold ? 'font-medium' : undefined}>{value ?? '-'}</p>
    </span>
  )
}
